module.exports = __webpack_public_path__ + "img/location.4daef9df.svg";